import { appendQueryParams, axiosErrorMessage } from "@hubrise/react-components"
import type { Method } from "@hubrise/react-components"
import axios, { AxiosError, isAxiosError } from "axios"
import type { RawAxiosRequestConfig, AxiosResponse } from "axios"

import { redirectToLogin } from "./browser"

/**
 * Send a request to the server with the given method and url.
 */
export const axiosServer = async <Data>(
  method: Method,
  url: string,
  appInstanceId: string,
  axiosConfig: RawAxiosRequestConfig = {},
): Promise<AxiosResponse<Data>> => {
  try {
    const params = { app_instance_id: appInstanceId }
    return await axios({
      method,
      url: appendQueryParams(url, params),
      ...axiosConfig,
    })
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response?.status === 401) {
        const message = (error as AxiosError<{ message: string }>).response!.data?.message
        if (message === "Not logged in") {
          redirectToLogin(appInstanceId)
        } else {
          alert(message)
        }
      } else {
        console.log(axiosErrorMessage(error))
      }
    }
    throw error
  }
}
